export default __webpack_public_path__ + "static/media/towerstack-poster.1fad6169.jpg";